import styled from "styled-components";
import { Mobile_query_v2 } from "../../../util/Query";

const LetsTalks = () => {
  return (
    <Container>
      <div className="title">Lets Talk</div>
      <div className="desc">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim
        veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
        commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
        velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
        occaecat cupidatat non proident, sunt in culpa qui officia deserunt
        mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur
        adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
        magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
        laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
        in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
        pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa
        qui officia deserunt mollit anim id est laborum.
      </div>
    </Container>
  );
};

export default LetsTalks;

const Container = styled.div`
  .desc {
    font-family: "Mulish";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 36px;
    /* or 180% */

    text-align: justify;

    /* Black 3 */

    color: rgba(12, 27, 77, 0.6);
  }
  .title {
    margin-bottom: 28px;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 700;
    font-size: 40px;
    line-height: 32px;
    /* or 80% */

    color: #3b3e98;
  }

  padding: 48px 93px;
  background-color: #ffff;

  ${Mobile_query_v2} {
    padding: 0 25px;
  }
  @media only screen and (min-width: 1366px) {
    margin: auto;
  }
`;
